import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';

export default class JournalistOnNews extends PureComponent {
    render() {
        if (this.props.journalistName) {
            const image = `https://a1media.antena1.com.br/image/journalists/70x70/${this.props.journalistImageFile}`;

            return (
                <div className="journalistContainer">
                    <Button to={`/jornalistas/${this.props.journalistSlug}`} title={`Leia mais sobre ${this.props.journalistName}`}>
                        <div className="journalistImageSm">
                            <img src={image} alt={`Imagem de ${this.props.journalistName}`} />
                        </div>
                    </Button>
                    <Button className="journalistName" to={`/jornalistas/${this.props.journalistSlug}`} title={`Leia mais sobre ${this.props.journalistName}`}>
                        {this.props.journalistName}
                        <br />
                        <span> jornalista </span>
                    </Button>
                </div>
            );
        }

        return (
            <div className="journalistContainer">
                <p className="others">
                    {this.props.authorName}
                </p>
            </div>

        );
    }
}

JournalistOnNews.propTypes = exact({
    authorName: PropTypes.string,
    journalistName: PropTypes.string,
    journalistSlug: PropTypes.string,
    journalistImageFile: PropTypes.string,
});
